import React from 'react'
import { ReactComponent as MicrophoneIcon } from 'assets/svgs/microphone-icon.svg'

interface AppVoiceIndicatorProps {
  transcript: string
  duration?: number
  className?: string
}

export const AppVoiceIndicator: React.FC<AppVoiceIndicatorProps> = ({
  transcript,
  duration = 0,
  className = '',
}) => {
  const formatDuration = (seconds: number): string => {
    // Ensure at least 1 second is displayed for any voice message
    const displaySeconds = Math.max(1, seconds)
    const mins = Math.floor(displaySeconds / 60)
    const secs = displaySeconds % 60
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <div
      className={`bg-app-grey-20 text-app-grey-10 rounded-lg px-3 py-2 max-w-[90%] ${className}`}
    >
      {/* Voice message content */}
      <div className="text-sm mb-2">"{transcript}"</div>

      {/* Voice indicator bar */}
      <div className="flex items-center gap-2 text-xs text-app-grey-40">
        <MicrophoneIcon className="w-3 h-3 text-app-grey-40" />
        <span>{formatDuration(duration)}</span>
      </div>
    </div>
  )
}
